import { render } from "./rteEditor.vue?vue&type=template&id=5852b774&ts=true"
import script from "./rteEditor.vue?vue&type=script&lang=ts"
export * from "./rteEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__